import FJTextStyle from './FJTextStyle';
import FJShadow from './style/FJShadow';
import FJOutline from './style/FJOutline';

class FJTextStyleNeon extends FJTextStyle {
    initStyles(props = {}) {
        let shadow = new FJShadow({
            ...props,
            offset: 0,
            angle: 0,
            blur: 20,
            color: '#EC18FF',
            opacity: 80,
            position: 'relative',
        });
        let shadow1 = new FJShadow({
            ...props,
            offset: 0,
            angle: 0,
            blur: 30,
            opacity: 80,
            color: '#EC18FF',
            position: 'absolute',
        });

        let textOutline = new FJOutline({
            ...props,
            width: 20,
            color: '#D33FE0',
            position: 'absolute',
            widthRef: 1400,
            textColor: 'rgba(255,255,255, 0.4)',
        });
        this._styles = [shadow, shadow1, textOutline];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{outlineColor: *, width: *, blur: *, opacity: *, shadowColor: *}}
     */
    getAdjustInfo() {
        let outline = this._styles[2];
        let shadow = this._styles[0];
        return {
            width: outline.width,
            blur: shadow.blur,
            opacity: shadow.opacity,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        if (info.width !== '') this._styles[2].width = info.width;
        if (info.blur !== '') this._styles[0].blur = info.blur;
        if (info.opacity !== '') {
            this._styles[0].opacity = info.opacity;
            this._styles[1].opacity = info.opacity;
        }
        if (info.blur !== '') this._styles[1].blur = info.blur + 10;
    }

    /**
     * @description 设置color
     * @param color
     */
    setColor(color) {
        this._styles[0].color = color;
        this._styles[1].color = color;
        this._styles[2].color = color;
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;
        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach((style, index) => {
            style.addToView(view, textData, { ...options, isAddToSupportLayer: index !== this._styles.length - 1 });
        });
    }
}

export default FJTextStyleNeon;
